import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import VehicleServices from '../../services/VehicleServices';
import BrandServices from '../../services/BrandServices';

function AddVehicle() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        name: '',
        brand: '',
        type: '', // Add type field here
    });

    
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        const fetchBrands = async () => {
            try {
                if (formValues.type) {
                    const res = await BrandServices.getBrandByType(formValues.type);
                    if (res.status) {
                        setBrands(res.data);
                    } else {
                        alert('Failed to fetch brands');
                    }
                } else {
                    setBrands([]); // Clear brands if no type is selected
                }
            } catch (error) {
                console.error('Error fetching brands', error);
                alert('Failed to fetch brands');
            }
        };
        fetchBrands();
    }, [formValues.type]); // Update when type changes

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            for (const key in formValues) {
                formData.append(key, formValues[key]);
            }

            await VehicleServices.createVehicle(formValues);
            alert('Vehicle Add successfully');
            navigate('/vehicle');

        } catch (error) {
            console.error('Failed to create vehicle', error);
            alert('Failed to create vehicle');
        }
    };

    return (
        <>
            <div className="right_col" role="main">
  <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                        Vehicle Add
                        </h5>
                        <nav>

                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                Vehicle Add                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center">

                        <div className="pe-1 mb-xl-0">

                            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
                            <Link className="list-banner-btn" to="/vehicle"> Vehicle List</Link>

                            </div>
                        </div>
                    </div>
                </div>
             
                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label>Select your Vehicle Type<span className="red">*</span></label>
                                            <select
                                                className="form-control"
                                                value={formValues.type}
                                                onChange={handleInputChange}
                                                name="type"
                                                
                                            >
                                                <option value="">--Select Type--</option>
                                                <option value="Car">Car</option>
                                                <option value="Bike or 3-Wheeler">Bike or 3-Wheeler</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label>Select your Brand<span className="red">*</span></label>
                                            <select
                                                name="brand"
                                                className="form-control"
                                                value={formValues.brand}
                                                onChange={handleInputChange}
                                                
                                            >
                                                <option value="">Select a brand</option>
                                                {brands.map((brand) => (
                                                    <option key={brand?._id} value={brand?._id}>
                                                        {brand?.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label>Enter Car Name<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Car Name"
                                                className="form-control"
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button className="submit-green-btn">SUBMIT</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddVehicle;
